import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type SignToPaidTrainingRequest = {
  trainingId: number
  cardToken: string
}

export const signToPaidTraining = async ({ trainingId, cardToken }: SignToPaidTrainingRequest) => {
  // Note: guests: 0 required by BE when training.guestsAllowed is true
  const response = await authAPI.put(`/training/${trainingId}`, { cardToken, guests: 0 })
  return response.data
}

export const useSignToPaidTraining = () => useMutation({ mutationFn: signToPaidTraining })
